export default __webpack_public_path__ + "3d1cd5775f9f1404e9489394af488db2.svg";